import React, { useState, useContext, useEffect } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { HerracContext } from '../../App';
import CabinetHeader from './CabinetHeader';
import CabinetSidebar from './CabinetSidebar';
import './CabinetLayout.css';

function CabinetLayout() {
  const { user, loading } = useContext(HerracContext);
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  // DEBUG - konsola bax
  console.log('🔍 CabinetLayout Debug:', { user, loading });

  // Handle responsive
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close sidebar on route change (mobile only)
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  // Prevent body scroll when sidebar open on mobile
  useEffect(() => {
    if (isMobile && sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [sidebarOpen, isMobile]);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  // Loading zamanı
  if (loading) {
    console.log('⏳ Loading...');
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <p>Yüklənir...</p>
      </div>
    );
  }

  // User yoxdursa
  if (!user) {
    console.log('❌ User yoxdur, /giris-ə yönləndirilir');
    return <Navigate to="/giris" state={{ from: location }} replace />;
  }

  console.log('✅ User var, cabinet göstərilir:', user);

  return (
    <div className="cabinet-layout">
      <CabinetHeader onMenuToggle={handleMenuToggle} isMobile={isMobile} />
      <div className="cabinet-layout__container">
        <CabinetSidebar
          isOpen={sidebarOpen}
          onClose={handleSidebarClose}
          isMobile={isMobile}
        />
        <main className="cabinet-layout__main">
          <div className="cabinet-layout__content">
            <Outlet />
          </div>
        </main>
      </div>
      {sidebarOpen && isMobile && (
        <div
          className="cabinet-layout__overlay"
          onClick={handleSidebarClose}
          aria-hidden="true"
        />
      )}
    </div>
  );
}

export default CabinetLayout;